import SeoHead from '../../components/SeoHead';

export default function PoliticaCookiesPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Política de Cookies – BN ĀGENZIA"
        description="Política de cookies de BN ĀGENZIA. Información sobre el uso de cookies técnicas en el sitio web y cómo configurar el navegador."
        canonical="/politica-cookies"
      />
      {/* Header */}
      <header className="bg-[#1A2B4A] py-6">
        <div className="max-w-4xl mx-auto px-8">
          <a href="/inicio" className="inline-flex items-center text-white hover:text-gray-200 transition-colors cursor-pointer">
            <i className="ri-arrow-left-line mr-2"></i>
            Volver al inicio
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-8 py-16">
        <h1 className="text-4xl font-bold text-[#1A2B4A] mb-8">Política de Cookies</h1>
        
        <div className="prose prose-lg max-w-none space-y-8">
          <section>
            <p className="text-gray-700 leading-relaxed">
              El sitio web de BN ĀGENZIA International Placement utiliza cookies técnicas necesarias para el correcto funcionamiento y navegación del sitio.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">¿Qué son las cookies?</h2>
            <p className="text-gray-700 leading-relaxed">
              Las cookies son pequeños archivos que se almacenan en el dispositivo del usuario con la finalidad de garantizar el funcionamiento adecuado del sitio web.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">Tipos de cookies utilizadas</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Actualmente no se utilizan cookies publicitarias ni de perfilado propias. No obstante, el proveedor del servicio de alojamiento o constructor web puede implementar cookies técnicas necesarias para la operatividad de la plataforma.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">Configuración del navegador</h2>
            <p className="text-gray-700 leading-relaxed">
              El usuario puede configurar su navegador para aceptar, bloquear o eliminar las cookies instaladas en su dispositivo.
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#F8F6F3] py-8 mt-16">
        <div className="max-w-4xl mx-auto px-8 text-center">
          <p className="text-sm text-gray-600">© 2025 BN ĀGENZIA. Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>
  );
}